import { useEffect } from "react";
import { startView, endView } from "../services/usageTrackingService";

/**
 * Record a modal open/close in usage tracking.
 * The shared ui/Modal calls this via its `trackAs` prop; custom modal shells call it directly.
 * Omit isOpen for modals that are only mounted while visible.
 */
export const useTrackModal = (name, isOpen = true) => {
  useEffect(() => {
    if (!isOpen || !name) return undefined;
    const viewId = startView("modal", name);
    return () => endView(viewId);
  }, [name, isOpen]);
};

export default useTrackModal;
